import { logger } from './../constants';
import { StateLoader } from './state-loader';

const init = () => {
  if (!window.GTMStateLoader) {
    // eslint-disable-next-line no-console
    window.GTMStateLoader = new StateLoader();
    logger('## GTM State Loader - dont found GTMStateLoader in window - create a new one', window.GTMStateLoader.state);
  }
}

export const GTMStateLoader = {
  getState: () => {
    init();
    return window.GTMStateLoader.state;
  },
  updateState: (state) => {
    init();
    window.GTMStateLoader.updateState(state);
  }
}
